const ACCIONES_EMPRESAS = [
  {
    idKey: 1,
    id: 1,
    name: 'Activar',
    activo: true
  },
  {
    idKey: 2,
    id: 1,
    name: 'Desactivar',
    activo: false
  },
  {
    idKey: 3,
    id: 2,
    name: 'Activar enviar avisos',
    activo: true
  },
  {
    idKey: 4,
    id: 2,
    name: 'Desactivar enviar avisos',
    activo: false
  },
  {
    idKey: 5,
    id: 3,
    name: 'Activar descarga automática',
    activo: true
  },
  {
    idKey: 6,
    id: 3,
    name: 'Desactivar descarga automática',
    activo: false
  },
  {
    idKey: 8,
    id: 50,
    name: 'Editar campos',
    activo: false
  },
  {
    idKey: 12,
    id: 12,
    name: 'Vincular a agrupación',
    activo: false
  },
  {
    idKey: 14,
    id: 14,
    name: 'Marcar alerta revisada',
    activo: false
  },
  {
    idKey: 9,
    id: 6,
    name: 'Gestionar días cortesía AEAT',
    activo: false
  },
  {
    idKey: 10,
    id: 7,
    name: 'Reintentar solicitud de días cortesía AEAT',
    activo: false
  },
  {
    idKey: 11,
    id: 8,
    name: 'Cancelar solicitud fallida de días cortesía AEAT',
    activo: false
  },
  {
    idKey: 13,
    id: 13,
    name: 'Cancelar consulta fallida de días cortesía AEAT',
    activo: false
  },
  {
    idKey: 16,
    id: 5,
    name: 'Alertar por poderes delegados',
    activo: false
  },
  {
    idKey: 15,
    id: 5,
    name: 'No alertar por poderes delegados',
    activo: true
  },
  {
    idKey: 7,
    id: 4,
    name: 'Borrar',
    activo: false
  },
]

export {
  ACCIONES_EMPRESAS
}
